import { impersonateUser, searchUsers, stopImpersonateUser } from 'admin/services/impersonate/actions'
import { impersonationSelector } from 'admin/services/selectors'
import { clearFBTokens, clearUserData, getIntercomData, getUserData, resetPassword, toggleUserBlocked } from 'admin/services/users/actions'
import { parse } from 'query-string'
import { createElement, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { Observable } from 'rxjs'
import { message } from 'services/snackbar'
import StoreState, { StoreThunkDispatch } from 'store/state'
import Impersonate from './Impersonate'

interface ConnectedImpersonateProps {
  current: any,
  search: (query: string) => Observable<any>
  impersonate: (user: any) => any
  stopImpersonation: () => void
  clearFBTokens: (id: string) => Observable<any>
  toggleUserBlocked: (id: string) => Observable<any>
  getIntercomData: (id: string) => Observable<any>
  message: (text: string) => void
  resetPassword: (userId: string) => Observable<any>
  clearUserData: (userId: string) => Observable<any>
  getUserData: (userId: string) => Observable<any>
}

export function ImpersonateContainer(props: ConnectedImpersonateProps) {
  const { search } = props
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = parse(location.search)
  const [searchUsersResult, setSearchUsersResult] = useState([])
  const [searchError, setSearchError] = useState('')
  const [loading, setLoading] = useState(false)

  const searchUsers = useCallback((query: string) => {
    setLoading(true)
    setSearchError('')
    return search(query)
      .subscribe(
        (users) => {
          setSearchUsersResult(users)
          setSearchError('')
          setLoading(false)
        },
        (error) => {
          setSearchError('There was a problem with your request. Please try again. \n' + error)
          setLoading(false)
        }
      )
  }, [search])

  useEffect(() => {
    if (queryParams?.userId) {
      searchUsers(queryParams.userId as string)
      navigate('/admin/support/users', { replace: true })
    }
  }, [queryParams.userId, navigate, searchUsers])

  const onClearSearch = () => {
    setSearchUsersResult([])
    setSearchError('')
  }

  return createElement(Impersonate, {
    current: props.current,
    users: searchUsersResult,
    searchError,
    loading,
    onSearch: searchUsers,
    onImpersonate: props.impersonate,
    onStopImpersonation: props.stopImpersonation,
    onClearSearch,
    onClearFBTokens: props.clearFBTokens,
    toggleUserBlocked: props.toggleUserBlocked,
    getIntercomData: props.getIntercomData,
    message: props.message,
    resetPassword: props.resetPassword,
    clearUserData: props.clearUserData,
    getUserData: props.getUserData
  })
}

function mapStateToProps(state: StoreState) {
  return {
    current: impersonationSelector(state)
  }
}

function mapDispatchToProps(dispatch: StoreThunkDispatch) {
  return {
    search: (query: string) => dispatch(searchUsers(query)),
    impersonate: (user: any) => dispatch(impersonateUser(user)),
    stopImpersonation: () => dispatch(stopImpersonateUser()),
    clearFBTokens: (id: string) => dispatch(clearFBTokens(id)),
    toggleUserBlocked: (id: string) => dispatch(toggleUserBlocked(id)),
    getIntercomData: (id: string) => dispatch(getIntercomData(id)),
    message: (text: string) => dispatch(message(text)),
    resetPassword: (userId: string) => dispatch(resetPassword(userId)),
    clearUserData: (userId: string) => dispatch(clearUserData(userId)),
    getUserData: (userId: string) => dispatch(getUserData(userId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonateContainer)
